export const menuList = [
  {
    icon: 'mdi-account-cog',
    items: [
      //{ title: 'โรล', icon: 'mdi-account-key', action: '/admin/users-management/roles' },
      //{ title: 'สิทธิ์การใช้งาน', icon: 'mdi-account-multiple-plus', action: '/users-management/permission'},
      { title: 'ผู้ใช้งานระบบ', icon: 'mdi-account-box-multiple', action: '/admin/users-management/users' },

    ],
    title: 'ผู้ใช้งานระบบ',
  },
  /*
   {
     icon: 'mdi-application-import',
     items: [
       { title: 'รายการขาย', icon: 'mdi-database-import', action: '/admin/import/sale-order' },
       { title: 'รายชื่อสมาชิก', icon: 'mdi-database-import', action: '/admin/import/contact' },
     ],
     title: 'Import',
   },
*/
  //----- settings --------------------------------
  {
    icon: 'mdi-tune',
    active: true,
    items: [
      { title: 'กำหนดวันสิ้นสุดของคะแนน', icon: 'mdi-file', action: '/admin/settings/point/expire' },
      { title: 'กำหนดวันสิ้นสุด Tier', icon: 'mdi-file', action: '/admin/settings/tier/expire' },
      //{ title: 'กำหนดมูลค่าของคะแนน', icon: 'mdi-file', action: '/admin/settings/point/value' },
      { title: 'คะแนน', icon: 'mdi-file', action: '/admin/settings/point' },
      { title: 'Greeting point', icon: 'mdi-alpha-p-circle', action: '/admin/settings/greeting-point' },
      { title: 'QR point', icon: 'mdi-alpha-p-circle', action: '/admin/settings/get-point-by-qr' },
      { title: 'เงื่อนไขและกติกา', code:"Terms",icon: 'mdi-file', action: '/admin/settings/terms' },
      //{ title: 'การชำระเงิน', code:"Payment", icon: 'mdi-file', action: '/admin/settings/payment' },
      { title: 'ข้อมูลลิงค์', icon: 'mdi-file', action: '/admin/settings/line-link' },
      //{ title: 'HubSpot APIKEY', icon: 'mdi-file', action: '/admin/settings/hubspot' },
    ],
    title: 'การตั้งค่า',
  },
  {
    icon: 'mdi-tune',
    active: true,
    items: [
      //{ title: 'ของรางวัล', icon: 'mdi-gift', action: '/admin/settings/rewards' },
      //{ title: 'สร้างรหัสสะสมคะแนน', icon: 'mdi-qrcode', action: '/admin/settings/code' },
      { title: 'หมวดหมู่สินค้า', icon: 'mdi-file-tree', action: '/admin/settings/category' },
      { title: 'สินค้า', icon: 'mdi-file', action: '/admin/settings/products' },

    ],
    title: 'สินค้า',
  },
  {
    icon: 'mdi-wallet-giftcard',
    active: true,
    items: [
      { title: 'ของรางวัล', icon: 'mdi-gift', action: '/admin/settings/rewards' },

    ],
    title: 'ของรางวัล',
  },
  // {
  //   icon: 'mdi-tune',
  //   active: true,
  //   items: [
  //     { title: 'คะแนน', icon: 'mdi-alpha-p-circle', action: '/admin/settings/point' },
  //     { title: 'ตั้งค่าคะแนน Greeting', icon: 'mdi-alpha-p-circle', action: '/admin/settings/greeting-point' },

  //   ],
  //   title: 'จัดการคะแนน',
  // },
  // {
  //   icon: 'mdi-tune',
  //   active: true,
  //   items: [
  //     { title: 'เงื่อนไขการใช้บริการ', code: "terms", icon: 'mdi-shield-alert', action: '/admin/settings/terms' },
  //     { title: 'การชำระเงิน', code: "payment", icon: 'mdi-credit-card-outline', action: '/admin/settings/payment' },
  //     //{ title: 'จัดการลิงค์ไลน์', icon: 'mdi-alpha-p-circle', action: '/admin/settings/line-link' },

  //   ],
  //   title: 'จัดการเนื้อหา',
  // },


  {
    icon: 'mdi-gift-open',
    items: [

      //{ title: 'รายการขาย', icon: 'mdi-point-of-sale', action: '/admin/sales/sales-list' },
      //{ title: "ประวัติการแลก ของรางวัล", icon: 'mdi-point-of-sale', action: '/admin/redeem/redeem-list' },
      //{ title: 'สแกนแลกของรางวัล', icon: 'mdi-point-of-sale', action: '/admin/redeem/qr' },
      //{ title: 'ลัคกี้ดรอว์', icon: 'mdi-point-of-sale', action: '/admin/redeem/lucky-draw' },
      { title: "จัดส่งสินค้า", icon: 'mdi-point-of-sale', action: '/admin/redeem/redeem-goods-list' },
      { title: "สแกน QR Code", icon: 'mdi-point-of-sale', action: '/admin/redeem/redeem-code-list' },
      { title: "แลกสิทธิพิเศษ", icon: 'mdi-point-of-sale', action: '/admin/redeem/redeem-privilege-list' },
      //{ title: 'ชิงโชค', icon: 'mdi-point-of-sale', action: '/admin/redeem/lucky-draw' },
      { title: 'เพิ่มลดคะแนนสมาชิก', icon: 'mdi-alpha-p-circle', action: '/admin/members/adjust-point' },

    ],
    disabled: true,
    title: 'แลกของรางวัล',
  },
  {
    icon: 'mdi-point-of-sale',
    items: [
      //{ title: 'รายชื่อลูกค้า (OGF) ', icon: 'mdi-account-box-multiple', action: '/admin/customers/customers-list' },
      { title: 'รายการขาย', icon: 'mdi-format-list-bulleted-square', action: '/admin/sales/sales-list' },
    ],
    disabled: true,
    title: 'รายการขาย',
  },

  {
    icon: 'mdi-account-group',
    items: [
      //{ title: 'รายชื่อลูกค้า (OGF) ', icon: 'mdi-account-box-multiple', action: '/admin/customers/customers-list' },
      { title: 'รายชื่อสมาชิก', icon: 'mdi-account-box-multiple', action: '/admin/members/members-list' },
      { title: 'สิทธิพิเศษ (Privileges)', icon: 'mdi-account-box-multiple', action: '/admin/members/privileges-list' },
      //{ title: 'บัตรสมาชิก (Member Card)', icon: 'mdi-account-box-multiple', action: '/admin/members/card' },
      { title: 'ระดับสมาชิก (Tiers)', icon: 'mdi-account-box-multiple', action: '/admin/members/tiers-list' },
    ],
    disabled: true,
    title: 'สมาชิก',
  },

  {
    icon: 'mdi-qrcode-scan',
    items: [
      { title: 'สแกนแลกของรางวัล', icon: 'mdi-qrcode-scan', action: '/admin/redeem/qr' },
      { title: 'สแกนแลกของสิทธิพิเศษ', icon: 'mdi-qrcode-scan', action: '/admin/redeem-privilege/qr' },

    ],
    disabled: true,
    title: 'สแกนแลกของรางวัล',
  },

  {
    icon: 'mdi-chart-multiple',
    items: [
      { title: 'Point flow', icon: '', action: '/admin/report/point-flow' },
      { title: 'Top Spender', icon: '', action: '/admin/report/member-report' },
      { title: 'Transactions', icon: '', action: '/admin/report/transactions' },
      { title: 'Money Flow', icon: '', action: '/admin/report/money-flow' },
      /*{ title: 'รายการจำนวนบิลของแต่ละร้านค้าที่ลูกค้านำมาแลกพอยท์', icon: '', action: '/admin/report/point-summary-by-product' },
      { title: 'จำนวนเฉลี่ยของการเข้ามาสะสมพอยท์', icon: '', action: '/admin/report/collect-point' },
      { title: 'จำนวนพอยท์ของลูกค้า', icon: '', action: '/admin/report/member-point' },
      { title: 'จำนวนคูปองถูกใช้รายร้านค้า', icon: '', action: '/admin/report/point-summary-by-reward' },
      */
    ],
    disabled: true,
    title: 'รายงาน',


  },

]

export const shopMenuList = [

  //  {
  //    icon: 'mdi-tune',
  //    active: true,
  //    items: [
  //      { title: 'รูปแบบการคำนวณคะแนน', icon: 'mdi-alpha-p-circle', action: '/admin/settings/point' },
  //      { title: 'ของรางวัล', icon: 'mdi-gift', action: '/admin/settings/rewards'},
  //      //{ title: 'สร้างรหัสสะสมคะแนน', icon: 'mdi-qrcode', action: '/admin/settings/code' },
  //      { title: 'หมวดหมู่สินค้า', icon: 'mdi-file-tree', action: '/admin/settings/category' },
  //      { title: 'สินค้า', icon: 'mdi-file', action: '/admin/settings/products' },
  //      { title: 'เงื่อนไขการใช้บริการ', icon: 'mdi-shield-alert', action: '/admin/settings/terms' },
  //    ],
  //    title: 'ตั้งค่าระบบ',
  //  },
  {
    icon: 'mdi-account-group',
    items: [
      //{ title: 'รายชื่อลูกค้า (OGF) ', icon: 'mdi-account-box-multiple', action: '/admin/customers/customers-list' },
      { title: 'รายชื่อสมาชิก', icon: 'mdi-account-box-multiple', action: '/admin/members/members-list' },
    ],
    disabled: true,
    title: 'รายชื่อสมาชิก',
  },

  {
    icon: 'mdi-point-of-sale',
    items: [

      { title: 'รายการรอขาย', icon: 'mdi-point-of-sale', action: '/admin/sales/sales-pending' },
      { title: 'รายการแลกของรางวัล', icon: 'mdi-point-of-sale', action: '/admin/redeem/redeem-list' },
      { title: 'สแกนแลกของรางวัล', icon: 'mdi-point-of-sale', action: '/admin/redeem/qr' },
      { title: 'สแกนแลกของสิทธิพิเศษ', icon: 'mdi-qrcode-scan', action: '/admin/redeem-privilege/qr' },

    ],
    disabled: true,
    title: 'รายการขาย/แลกของรางวัล',
  },
  /*
     {
       icon: 'mdi-point-of-sale',
       items: [

           { title: 'รายการขาย', icon: 'mdi-point-of-sale', action: '/admin/sales/sales-list' },
       ],
       disabled: true,
       title: 'ข้อมูลการขาย',
     },
               */

  //  {
  //    icon: 'mdi-chart-multiple',
  //    items: [
  //        { title: 'Point flow' , icon: '', action:'/admin/report/point-flow'},
  //        { title: 'ข้อมูล Member' , icon: '', action:'/admin/report/member-report'},
  //        { title: 'รายการจำนวนบิลของแต่ละร้านค้าที่ลูกค้านำมาแลกพอยท์' , icon: '', action:'/admin/report/point-summary-by-product'},
  //        { title: 'จำนวนเฉลี่ยของการเข้ามาสะสมพอยท์' , icon: '', action:'/admin/report/collect-point'},
  //        { title: 'จำนวนพอยท์ของลูกค้า' , icon: '', action:'/admin/report/member-point'},
  //        { title: 'จำนวนคูปองถูกใช้รายร้านค้า' , icon: '', action:'/admin/report/point-summary-by-reward'},
  //    ],
  //    disabled: true,
  //    title: 'รายงาน',


  //  },

]
